// Modules
import React, { useState } from 'react'

// Application
import AsideIllustration from 'assets/aside-illustration.svg'
import { userPathDetect } from 'utils'

// Component
import {
    Button,
    ButtonContainer,
    Chevron,
    Container,
    Illustration,
    Title,
    Icon,
    AccessText,
    VectorImg,
    TitleLaboratory,
    IllustrationContainer,
    BackgroundColor,
    LaboratoriesContainer,
    ContentContainer,
} from './styles'
import { AgExams, ChevronRight, MedicalCalendar } from '@dasa-health/alma-icons'
import { CustonModalOrBootomSheet } from 'redesign/components/molecules/CustomModalOrBottomSheet'
import { CustomModalOrBottomSheetLogin } from 'redesign/components/molecules/CustomModalOrBottomSheetLogin'
import { Overline } from '@dasa-health/alma-react'
import Vector from 'assets/Vector.svg'
import LogoCarousel from 'components/LogoCarousel'
import { LogoCarouselContainer } from 'components/LogoCarousel/styles'

export const Aside = () => {
    const [showModalOrBottomSheetOtp, setShowModalOrBottomSheetOtp] = useState(false)
    const [showScheduleExam, setShowScheduleExam] = useState(false)
    const { isLoginPage } = userPathDetect()

    const DATA = {
        title: showScheduleExam ? 'Agendar exames' : 'Conferir resultados de exames',
        subtitle: 'Para continuar, insira o CPF do paciente',
    }

    const handleOpenScheduleExam = () => {
        setShowScheduleExam(true)
        setShowModalOrBottomSheetOtp(true)
        sessionStorage.setItem('@redirectToUrl', '/agd-exames/paciente?origin=Acesso-Facil')
    }

    const handleOpenCheckResult = () => {
        setShowScheduleExam(false)
        setShowModalOrBottomSheetOtp(true)
        sessionStorage.setItem('@redirectToUrl', '/exames?origin=Acesso-Facil')
    }

    return (
        <BackgroundColor>
            <Container>
                <IllustrationContainer>
                    <Illustration alt="Aside" src={AsideIllustration} />
                </IllustrationContainer>
                <ContentContainer>
                    <Title>
                        Seu assistente de saúde <br /> pra&nbsp;toda&nbsp;a&nbsp;vida
                    </Title>
                    <CustonModalOrBootomSheet
                        setShowModal={setShowModalOrBottomSheetOtp}
                        showCloseButtonModal={false}
                        showModal={showModalOrBottomSheetOtp}
                        title={DATA.title}
                    >
                        <p>{DATA.subtitle}</p>
                        <CustomModalOrBottomSheetLogin
                            onClose={() => {
                                sessionStorage.removeItem('@redirectToUrl')
                                setShowModalOrBottomSheetOtp(false)
                            }}
                        />
                    </CustonModalOrBootomSheet>
                    {isLoginPage && (
                        <ButtonContainer>
                            <AccessText>
                                <Overline>ACESSO FÁCIL</Overline>
                            </AccessText>
                            <VectorImg alt="Vector" src={Vector} />
                            <Button
                                data-current-service="Login faseado"
                                data-item-position="Acesso rápido"
                                data-item-text="Conferir resultados"
                                data-testid="bottom-sheet-checkResult"
                                onClick={() => handleOpenCheckResult()}
                            >
                                <Chevron>
                                    <Icon color="#ff4e33">
                                        <AgExams />
                                    </Icon>
                                    <Icon transparent>
                                        <ChevronRight />
                                    </Icon>
                                </Chevron>
                                <span>Conferir resultados</span>
                            </Button>
                            <Button
                                data-current-service="Login faseado"
                                data-item-position="Acesso rápido"
                                data-item-text="Agendar exames"
                                data-testid="bottom-sheet-scheduleExam"
                                onClick={() => handleOpenScheduleExam()}
                            >
                                <Chevron gap>
                                    <Icon>
                                        <MedicalCalendar />
                                    </Icon>
                                    <Icon transparent>
                                        <ChevronRight />
                                    </Icon>
                                </Chevron>
                                <span>Agendar exames</span>
                            </Button>
                        </ButtonContainer>
                    )}
                </ContentContainer>
                <LaboratoriesContainer>
                    <TitleLaboratory>Conecto você a laboratórios de todo o país</TitleLaboratory>
                    <LogoCarouselContainer>
                        <LogoCarousel />
                    </LogoCarouselContainer>
                </LaboratoriesContainer>
            </Container>
        </BackgroundColor>
    )
}
